// Discount apps can update a line's labels after Shopify renders its subscription option.
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const normalizeTitle = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const syncSubscriptionDiscounts = () => {
    const settings = drawer.querySelector('[data-hide-subscribe-discounts]');
    const excludedTitles = new Set(
      (settings?.getAttribute('data-hide-subscribe-discounts') || '')
        .split(/[\r\n,]+/)
        .map(normalizeTitle)
        .filter(Boolean)
    );

    drawer.querySelectorAll('.cart-item').forEach((item) => {
      const subscription = item.querySelector('.cart-item__subscription');
      if (!subscription) return;

      const matches = Array.from(item.querySelectorAll('.discounts__discount')).some(
        (discount) => excludedTitles.has(normalizeTitle(discount.textContent))
      );
      subscription.toggleAttribute('data-discount-hidden', matches);
    });
  };

  syncSubscriptionDiscounts();
  // The drawer element persists while its contents are replaced on cart updates.
  // Ignore our visibility attribute to avoid an observer feedback loop.
  new MutationObserver(syncSubscriptionDiscounts).observe(drawer, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-hide-subscribe-discounts'],
  });
})();
